import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const useForgotPassword = (performForgotPassword) => {
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    handleSubmit,
    register,
    watch,
    formState: { errors }
  } = useForm();

  const email = watch('email');

  const onSubmit = handleSubmit(async ({ email }) => {
    setLoginError('');
    setSuccessMessage('');
    setIsSubmitting(true);

    try {
      const response = await performForgotPassword(email);
      const data = await response.json();

      if (!response.ok) {
        setLoginError(data?.message || 'Usuario no encontrado!');
        setIsSubmitting(false);
      } else {
        setSuccessMessage(data?.message || '¡Revisa tu correo electrónico!');
        setTimeout(() => {
          navigate('/login');
          setIsSubmitting(false);
        }, 5000); // wait 5 seconds before redirect
      }
    } catch (error) {
      setLoginError('Error del servidor. Inténtalo de nuevo más tarde.');
      setIsSubmitting(false);
    }
  });

  return {
    errors,
    onSubmit,
    register,
    loginError,
    successMessage,
    isSubmitting,
    email,
    setLoginError
  };
};

export default useForgotPassword;
